<script setup>
import { useI18n } from 'vue-i18n';
import { Kbd, KbdGroup } from 'next/polaris/ui/kbd';

const { t } = useI18n();

const keyShortcuts = [
  { key: 'K', description: t('CONVERSATION.EMPTY_STATE.CMD_BAR') },
  { key: '/', description: t('CONVERSATION.EMPTY_STATE.KEYBOARD_SHORTCUTS') },
];
</script>

<template>
  <div class="flex flex-col gap-2">
    <div
      v-for="keyShortcut in keyShortcuts"
      :key="keyShortcut.key"
      class="flex items-center gap-2"
    >
      <KbdGroup>
        <Kbd>⌘</Kbd>
        <Kbd>{{ keyShortcut.key }}</Kbd>
      </KbdGroup>
      <span class="type-polaris-caption text-polaris-muted-foreground">
        {{ keyShortcut.description }}
      </span>
    </div>
  </div>
</template>
